import { render, staticRenderFns } from "./PromotionRewardsCard.vue?vue&type=template&id=d685e6d4&scoped=true&"
import script from "./PromotionRewardsCard.vue?vue&type=script&lang=js&"
export * from "./PromotionRewardsCard.vue?vue&type=script&lang=js&"
import style0 from "./PromotionRewardsCard.vue?vue&type=style&index=0&id=d685e6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d685e6d4",
  null
  
)

export default component.exports